<div class="spinner-Overlay" *ngIf="displaySpinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<div class="backdrop hilCase-modal" >
  <div class="case-details-container">
    <div class="case-details-modal-header" >
      <div class="case-details-header">
          {{ "HILCaseDetails.caseID" | translate }} {{ data.id }}
      </div>
      <div class="close">
        <img
          (click)="onCancel()"
          id="close"
          src="assets\images\close_icon.png"
          alt="{{ 'HILCaseDetails.Close' | translate }}"
          title="{{ 'HILCaseDetails.Close' | translate }}"
        />
      </div>
    </div>
    <div mat-dialog-content>
      <div class="modal-body">
        <!-- Section 1-->
        <div
          [ngClass]="{
            noBordrsection1: !isManagerFlag,
            section1: isManagerFlag
          }"
        >
          <div class="row" *ngIf="showCaseFlag">
            <!-- Section for Labels -->
            <div class="col-5 label-font">
              <p>{{ "HILCaseDetails.uploadDate" | translate }}</p>
              <p>{{ "HILCaseDetails.applicationName" | translate }}</p>
              <p>{{ "HILCaseDetails.anatomy" | translate }}</p>
              <p>{{ "HILCaseDetails.type" | translate }}</p>
              <p>{{ "HILCaseDetails.reviewer" | translate }}</p>
              <p>{{ "HILCaseDetails.finishedDate" | translate }}</p>
            </div>
            <!-- Section for Values -->
            <div class="col-7 value-font">
              <p>{{ hilCaseDetails.createdDateTime | localtimezone :'sec' }}</p>
              <p>{{ hilCaseDetails.applicationName }}</p>
              <p>{{ hilCaseDetails.caseType | titlecase }}</p>
              <p>{{ hilCaseDetails.imagingType }}</p>
              <p>
                <span *ngIf="hilCaseDetails.claimantFirstName != notApplicable">
                {{ hilCaseDetails.claimantFirstName }}
                {{ hilCaseDetails.claimantLastName }}</span>
              </p>
              <p>
                <span  *ngIf="data.status === statusRejected || data.status === statusApproved || data.status === statusError">
                {{ hilCaseDetails.updatedDateTime | localtimezone :'sec' }}</span>
              </p>
            </div>
          </div>
  
          <div
            *ngIf="data.status === statusRejected && showCaseFlag"
            class="section2 mx-auto col-11"
          >
            <div>
              <p id="section-titles-err">
                {{ "HILCaseDetails.errorNotes" | translate }}
              </p>
              <!-- Section for Values -->
              <div class="col-7 value-font-error">
                <p>
                  {{ hilCaseDetails.errorNotes }}
                </p>
              </div>
            </div>
          </div>
  
          <!-- Section to display ImageCenter Details -->
          <div
            *ngIf="isManagerFlag && showImgCenterFlag"
            class="section3 mx-auto col-11"
          >
            <hr class="brClass" />
            <p id="section-titles-img">
              {{ "HILCaseDetails.imgCenterDtls" | translate }}
            </p>
            <div class="row">
              <div class="col-5 label-font">
                <p class="addWrap">{{ imgCenterDetails.facilityName }}</p>
                <p class="addWrap" title="{{ imgCenterDetails.address }}">
                  {{ imgCenterDetails.address }}
                </p>
                <p class="addWrap">
                  {{ imgCenterDetails.city }} , {{ imgCenterDetails.state }}
                  {{ imgCenterDetails.zipCode }}
                </p>
              </div>
              <!-- Section for Values -->
              <div class="col-7 value-font">
                <p class="addWrap">{{ imgCenterDetails.facilityContactLead }}</p>
                <p class="addWrap">{{ imgCenterDetails.facilityEmail }}</p>
                <p>{{ imgCenterDetails.facilityPhone }}</p>
              </div>
            </div>
          </div>
        </div>
        <button class="case-management-close-button font-SN-core" (click)="onCancel()">
          {{ "HILCaseDetails.BtnClose" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
